import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UsuarioLoginResponse } from "../models/usuarioLoginResponse.model";
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginHelper {
  private loginSubject: BehaviorSubject<UsuarioLoginResponse | null> = new BehaviorSubject<UsuarioLoginResponse | null>(null);

  constructor(private router: Router) {}

  login_user: string = 'LOGIN_USER';

  signIn(login: UsuarioLoginResponse): Observable<void> {
    return new Observable(observer => {
      if (typeof localStorage !== 'undefined') {
        let json = JSON.stringify(login);
        localStorage.setItem(this.login_user, json);
        this.loginSubject.next(login);
        observer.next();
        observer.complete();
      } else {
        observer.error('LocalStorage not available');
      }
    });
  }
  clearSession(): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(this.login_user);
      this.loginSubject.next(null);
    }
  }

  signOut(): void {
    this.clearSession();
    void this.router.navigate(['/login']);
  }

  get(): UsuarioLoginResponse | null {
    if (typeof localStorage !== 'undefined') {
      let login = localStorage.getItem(this.login_user);
      if (login != null) {
        return JSON.parse(login) as UsuarioLoginResponse;
      }
    }
    return null;
  }

  getLoginObservable(): Observable<UsuarioLoginResponse | null> {
    return this.loginSubject.asObservable();
  }
}
